import React, { useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { HiOutlineArrowLeft } from "react-icons/hi";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import axios from "axios";
import { server } from "../../server";
import { toast } from "react-toastify";
import { loadUser } from "../../redux/actions/user";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${server}/user/login-user`, { email, password }, { withCredentials: true });
      await dispatch(loadUser());
      const { data } = await axios.get(`${server}/user/getuser`, { withCredentials: true });
      toast.success("Login Successful!");
      if (data.user && (data.user.role === "Admin" || data.user.role === "SubAdmin" || data.user.role === "Manager")) {
        navigate("/admin/dashboard");
      } else if (data.user && data.user.role === "store_manager") {
        navigate("/store-manager");
      } else {
        navigate("/");
      }
    } catch (err) {
      const msg = err.response?.data?.message || "Login failed";
      if (msg.includes("You are registered as a Supplier") || msg.includes("Please use the Shop Login")) {
        toast.error("You are a Supplier. Please use Shop Login.");
        navigate("/shop-login");
      } else {
        toast.error(msg);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col lg:flex-row">
      {/* Left: Brand panel */}
      <div className="hidden lg:flex lg:w-1/2 bg-black flex-col justify-between p-14">
        <Link to="/" className="flex items-center gap-3">
          <img src="/logo (10).png" alt="Logo" className="h-10 w-auto invert brightness-200 object-contain" />
        </Link>
        <div>
          <p className="text-xs uppercase tracking-[0.25em] text-accent-500 mb-4">Welcome Back</p>
          <h1 className="text-4xl font-bold text-white leading-snug mb-6">
            Your wellness<br />journey continues.
          </h1>
          <p className="text-secondary-400 text-sm leading-relaxed max-w-sm">
            Sign in to access your orders, track deliveries, and explore our curated collection of Ayurvedic & handcrafted wellness products.
          </p>
        </div>
        <p className="text-secondary-600 text-xs">© {new Date().getFullYear()} Positive Moments</p>
      </div>

      {/* Right: Form */}
      <div className="flex-1 flex flex-col justify-center px-6 sm:px-12 lg:px-16 py-12 relative">
        <button onClick={() => navigate("/")} className="absolute top-6 left-6 flex items-center gap-2 text-sm text-secondary-500 hover:text-black transition-colors">
          <HiOutlineArrowLeft className="w-4 h-4" /> Back
        </button>

        <div className="w-full max-w-sm mx-auto">
          <div className="lg:hidden flex justify-center mb-8">
            <img src="/logo (10).png" alt="Logo" className="h-10 w-auto object-contain" />
          </div>

          <p className="text-xs uppercase tracking-[0.2em] text-accent-600 mb-2">Account</p>
          <h2 className="text-3xl font-bold text-black mb-2">Sign in</h2>
          <p className="text-secondary-500 text-sm mb-8">
            Don't have an account?{" "}
            <Link to="/sign-up" className="text-black font-semibold underline underline-offset-2 hover:text-accent-600 transition-colors">
              Create one
            </Link>
          </p>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-xs font-semibold uppercase tracking-wider text-secondary-600 mb-2">Email</label>
              <input
                type="email" required placeholder="you@example.com" value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 border border-secondary-200 text-black placeholder-secondary-400 text-sm focus:outline-none focus:border-black transition-colors bg-white"
              />
            </div>

            <div>
              <div className="flex items-center justify-between mb-2">
                <label className="text-xs font-semibold uppercase tracking-wider text-secondary-600">Password</label>
                <Link to="/forgot-password" className="text-xs text-secondary-400 hover:text-black transition-colors">Forgot?</Link>
              </div>
              <div className="relative">
                <input
                  type={visible ? "text" : "password"} required placeholder="••••••••" value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full px-4 py-3 pr-12 border border-secondary-200 text-black placeholder-secondary-400 text-sm focus:outline-none focus:border-black transition-colors bg-white"
                />
                <button type="button" onClick={() => setVisible(!visible)} className="absolute right-3 top-1/2 -translate-y-1/2 text-secondary-400 hover:text-black transition-colors">
                  {visible ? <AiOutlineEye size={18} /> : <AiOutlineEyeInvisible size={18} />}
                </button>
              </div>
            </div>

            <button type="submit" disabled={loading}
              className="w-full py-3.5 bg-black text-white text-sm font-semibold uppercase tracking-wider hover:bg-secondary-800 transition-colors disabled:opacity-50 mt-2">
              {loading ? "Signing in" : "Sign In"}
            </button>
          </form>

          <div className="mt-6 pt-6 border-t border-secondary-100">
            <p className="text-xs text-secondary-400 uppercase tracking-wider text-center mb-3">Vendor Portal</p>
            <div className="grid grid-cols-2 gap-2">
              <Link
                to="/shop-login"
                className="py-2.5 border border-black text-black text-xs font-semibold uppercase tracking-wider text-center hover:bg-black hover:text-white transition-colors"
              >
                Vendor Login
              </Link>
              <Link
                to="/shop-create"
                className="py-2.5 bg-accent-500 text-black text-xs font-semibold uppercase tracking-wider text-center hover:bg-accent-400 transition-colors"
              >
                Become a Vendor
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
